/**
 * The filtered list, as a file.
 *
 * Spec 02-orders keeps CSV out of the bulk bar and on the toolbar: it exports what the
 * screen is showing, not what happens to be selected. The columns are the columns of the
 * table, in the same order, so the file and the screen are recognisably the same thing.
 */
import { dollars, toCsv } from '@/lib/csv';
import { MATCHER_LABEL, PAYMENT_STATE_LABEL, type OrdersPageRowView as OrdersPageRow } from './types';

export const CSV_HEADERS = [
  'Order',
  'Placed',
  'Customer',
  'City',
  'State',
  'Payment method',
  'Payment state',
  'Matcher',
  'Total',
  'Refunded',
  'Items',
  'Slip printed',
  'COA printed',
  'Label printed',
  'Fulfilment',
  'Carrier',
  'Tracking',
  'First order',
  'Attention',
] as const;

export function rowsToCsv(rows: readonly OrdersPageRow[]): string {
  return toCsv(
    CSV_HEADERS,
    rows.map((row) => [
      row.number,
      row.placed_at,
      row.customer.name,
      row.customer.city ?? '',
      row.customer.state ?? '',
      // Export is owner work (`orders.export`), so these are normally present. A role
      // without them gets an empty column rather than a zero that reads as a real amount.
      row.payment.method_label ?? '',
      PAYMENT_STATE_LABEL[row.payment.state],
      row.payment.matcher ? MATCHER_LABEL[row.payment.matcher] : '',
      row.total_cents !== undefined ? dollars(row.total_cents) : '',
      row.refunded_cents !== undefined && row.refunded_cents > 0 ? dollars(row.refunded_cents) : '',
      row.item_count,
      row.prints.slip_at ?? '',
      row.prints.coa_at ?? '',
      row.prints.label_at ?? '',
      row.fulfilment.state,
      row.fulfilment.carrier ?? '',
      row.fulfilment.tracking ?? '',
      row.flags.first_order ? 'yes' : 'no',
      row.attention_reasons.join(' '),
    ]),
  );
}
